<aside class="" [ngClass]="'sidebar flex-col ' + parentClass">
  <div class="sidebar__logo">
    <img src="assets/images/logo.svg" alt="NobleQuote" />
  </div>
  <nav>
    <ng-container *ngFor="let item of navItems">
      <span
        [routerLink]="[item.url]"
        [ngClass]="item.url === activeNav ? 'active' : ''"
        (click)="onCloseSideBar.emit()"
      >
        <picture>
          <img
            [src]="item.url === activeNav ? item.activeIcon : item.icon"
            [alt]="item.label"
          />
        </picture>
        {{ item.label }}
      </span>
    </ng-container>
  </nav>
</aside>
<div
  [ngClass]="'sidebar__backdrop ' + parentClass"
  (click)="closeSideBar()"
></div>
